import { render, staticRenderFns } from "./SeoMessageImageBlock.vue?vue&type=template&id=1c967f5a&"
import script from "./SeoMessageImageBlock.vue?vue&type=script&lang=js&"
export * from "./SeoMessageImageBlock.vue?vue&type=script&lang=js&"
import style0 from "./SeoMessageImageBlock.vue?vue&type=style&index=0&id=1c967f5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports